import { Colors } from '../consts/Colors'

export const TextContents = {
    popup: {
        text: "Dans cette deuxième étape, placez les quatre éléments qui différencient une procédure amiable d'une procédure collective.",
    },
    consigne: {
        text: "Placez les éléments qui différencient la procédure amiable de la procédure collective.",
        config: { size: '22px', fontFamily: 'MassiliaMediumOblique', align: 'left', color: Colors.Text.White, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 381 }
    },
    title : {
        text : "TRIBUNAUX DE COMMERCE",
        config: { size: '24px', fontFamily: 'MassiliaBold', align: 'left', color: Colors.Text.Red, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 333 }
    },
    subtitle : {
        text : "<class=\'regularOblique18\'>Étape 2</class>\nPROCÉDURE AMIABLE\nou PROCÉDURE COLLECTIVE",
        config: { size: '18px', fontFamily: 'MassiliaRegular', align: 'left', color: Colors.Text.White, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 333 }
    },

}

export const CartesInfos = [
    {
        titre: "Confidentielle",
        image: "label1",
        zoneId: 1,
        cardY: -227
    },
    {
        titre: "Non Confidentielle",
        image: "label2",
        zoneId: 3,
        cardY: -159
    },
    {
        titre: "Gel des dettes",
        image: "arrow1",
        zoneId: 4,
        cardY: -24
    },
    {
        titre: "Continue ses engagements",
        image: "arrow2",
        zoneId: 2,
        cardY: 116
    },
]
export const ZonesInfos = [
    {
        zoneX: 993,
        zoneY: 75,
        zoneXDeck: -671,
        zoneYDeck: -470,
        zoneId: 1,
        image: "labelPlaceholder",
    },
    {
        zoneX: 1048,
        zoneY: 387,
        zoneXDeck: -616,
        zoneYDeck: -158,
        zoneId: 2,
        image: "arrowPlaceholder",
    },
    {
        zoneX: 1048,
        zoneY: 583,
        zoneXDeck: -616,
        zoneYDeck: 38,
        zoneId: 3,
        image: "labelPlaceholder",
    },
    {
        zoneX: 682,
        zoneY: 870,
        zoneXDeck: -982,
        zoneYDeck: 325,
        zoneId: 4,
        image: "arrowPlaceholder",
    },
]